/* eslint-disable import/prefer-default-export */
import { notification } from '@webclient/components/notification';

import { auth } from '@webclient/lib/agent';

import useAppSelector from '@webclient/hooks/useAppSelector';
import useQueryParams from '@webclient/hooks/useQueryParams';

import { useQuery } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';

export function useGetUser() {
  const { t } = useTranslate();
  const { getQueryParamByKey } = useQueryParams();
  const contactTokenQueryParam = getQueryParamByKey<string | null>(
    'contact_token',
  );

  const isUserAuthenticated = useAppSelector(
    (state) => state.auth.isUserAuthenticated,
  );

  const { data: userData, isLoading: isLoadingUser } = useQuery({
    queryKey: ['me', contactTokenQueryParam],
    queryFn: async () => {
      try {
        const { data } = await auth.getMe(contactTokenQueryParam);
        return data;
      } catch (error) {
        notification.error({
          message: t(
            'response.errors.code.520',
            'Unknown error. Please try again later.',
          ),
        });
        console.error(error);
      }
    },
    enabled: isUserAuthenticated || contactTokenQueryParam !== null,
    staleTime: Infinity,
    retry: 3,
    refetchOnWindowFocus: true,
  });

  return { userData, isLoadingUser };
}
